import React, { useState, useEffect, forwardRef } from 'react';

const Img = forwardRef(({ src, alt, onError, ...props }, ref) => {
	const [useFallback, setUseFallback] = useState(false);

	useEffect(() => {
		setUseFallback(false);
	}, [src]);

	const handleError = (e) => {
		if (!useFallback && src) {
			setUseFallback(true);
		} else if (onError) {
			onError(e);
		}
	};

	const resolvedSrc = src && !useFallback
		? src.replace(/\.\w+(?=[?#]|$)/, '.webp')
		: src;

	return <img ref={ref} src={resolvedSrc} alt={alt} onError={handleError} {...props} />;
});

export default Img;
